export default __webpack_public_path__ + "img/d28819d9b81c00877caf53b1b45ccb4e.svg";